import React, { useState, useEffect } from "react";

import Reservation from "./layout";
import {
  ReservationProvider,
  useReservation,
} from "context/reservationContext";
import { useApp } from "context/appContext";
import { saveReservation, getOpenEvents } from "services/event.service";
import { getAllCCs } from "services/assistant.service";
import { orderEvents } from "utils/eventsUtils";
import {
  KID_01,
  ESP,
  DOM_01,
  MRC,
  DOM_02,
  KID_02,
  YOUNG,
  ESP_KID,
  PRIVATE,
  IGLEKIDS,
} from "constants/eventsConstants";

function ReservationContainer({ category }) {
  const {
    event,
    loading,
    assistants,
    setLoading,
    iglekids,
    setEvents,
    setEvent,
    setCcs,
    ticket,
  } = useReservation();
  const { showNotification } = useApp();
  const [showFinish, setShowFinish] = useState(false);
  const [reservation, setReservation] = useState({});

  const KID = "KID";

  const handleReserve = async () => {
    if (assistants.length) {
      let reservation;
      try {
        setLoading(true);
        const mappedAss = assistants.map(a => ({...a, id: null}))
        reservation = await saveReservation(event.id, mappedAss, ticket);
      } catch (error) {
        showNotification(error.message, "error");
        setLoading(false);
        return;
      }
      setReservation(reservation);
      setShowFinish(true);
      setLoading(false);
    } else {
      showNotification("No hay asistentes para registrar.", "error");
    }
  };

  const getTypeFilter = () => {
    if (iglekids || category === IGLEKIDS) {
      return `${KID_01},${KID_02}`;
    }
    if (category === PRIVATE) {
      return PRIVATE;
    }
    if (category === ESP) {
      return ESP;
    }
    if (category === YOUNG) {
      return YOUNG;
    }
    if (category === KID) {
      return ESP_KID;
    }
    if (category === "NORMAL") {
      return `${MRC},${DOM_01},${DOM_02}`;
    }
    return "";
  };

  useEffect(() => {
    async function loadEvents() {
      try {
        const type = getTypeFilter();
        const [openEvents, ccs] = await Promise.all([
          getOpenEvents(type),
          getAllCCs(),
        ]);
        setCcs(ccs);
        if (openEvents && openEvents.length) {
          const eventsOrdered = orderEvents(openEvents);
          setEvents(eventsOrdered);
          setEvent(eventsOrdered[0]);
        } else {
          setEvents([]);
          setEvent({});
        }
      } catch (error) {
        showNotification(
          "Ha ocurrido un error al consultar la información de los servicios.",
          "error"
        );
      }

      setLoading(false);
    }

    loadEvents();
    // eslint-disable-next-line
  }, [iglekids]);

  return (
    <Reservation
      loading={loading}
      showFinish={showFinish}
      onReserve={handleReserve}
      reservation={reservation}
      category={category}
    />
  );
}

export default ({ ...props }) => (
  <ReservationProvider>
    <ReservationContainer {...props} />
  </ReservationProvider>
);
